import React from "react";
import { useLang } from "../context/LangContext";

const BRANDS = [
  "CALVIN KLEIN",
  "EMPORIO ARMANI",
  "HUGO BOSS",
  "TOMMY HILFIGER",
  "VERSACE",
  "DIESEL",
  "RALPH LAUREN",
  "ABERCROMBIE",
  "DOLCE & GABBANA",
  "PRADA",
];

export default function BrandsMarquee() {
  const { t } = useLang();
  const items = [...BRANDS, ...BRANDS];

  return (
    <section data-testid="brands-marquee" className="relative py-16 lg:py-24 bg-[#050505] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-10">
        <div className="flex items-center gap-4">
          <span className="block w-12 h-px bg-[#00E5FF]" />
          <span className="label-eyebrow text-[#00E5FF]">Brands</span>
        </div>
        <h2 className="mt-4 font-display uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white max-w-3xl">
          {t.brands.title}
        </h2>
      </div>

      <div className="overflow-hidden relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10" />
        <div className="marquee-track flex gap-16 whitespace-nowrap">
          {items.map((b, i) => (
            <span
              key={i}
              className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl tracking-[0.15em] text-neutral-700 hover:text-white transition-colors duration-500 cursor-default"
            >
              {b}
              <span className="text-[#00E5FF] ml-16">/</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
